import { usePermissions } from "../../../hooks/usePermissions";
import { ClientProps } from "../../../interfaces/interfaces";
import { PumpModuleAdmin } from "../pump/PumpModuleAdmin";

interface Props {
  clientMode?: boolean;
  assignedClientOptions?: ClientProps[];
  assignedClientId?: number | null;
  onAssignedClientChange?: (clientId: number | null) => void;
}

export const PumpTrackerAdmin = (props: Props) => {
  const { canManagePumpTracker } = usePermissions();
  return (
    <PumpModuleAdmin
      apiPrefix="pump-tracker"
      title="Pump Tracker"
      canManage={canManagePumpTracker}
      {...props}
    />
  );
};
